<template>
	<div class="c-site-search__results c-site-search__results--loading o-grid__item" aria-hidden>

		<p class="c-site-search__query o-block" v-if="displayQuery" v-html="'Searching for ' + displayQuery"></p>

		<ul class="o-grid o-grid--contained o-list">
			<li
				class="o-grid__item o-block--column h-colspan--221"
				v-for="i in 12"
				:key="i"
			>
				<div class="c-media c-media--axiell c-media--loading">
					<div class="c-media__image">
						
					</div>
					<div
						class="c-media__title"
					></div>
					<div
						class="c-media__summary"
					></div>
					<div class="c-media__actions">

					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		mounted() {
		},
		props: ['displayQuery'],
		methods: {
			
		},
	};
</script>

